import { useState } from "react";
import { ReactComponent as Copy } from "../../../../../../../assets/images/svg/document-copy.svg";
import { post, responseValidator } from "../../../../../../../scripts/api";
import API from "../../../../../../../urls/api";
import { handleSetPublicLinkFolder } from "../../../../fileManager.actions";
import Dropdown from "../../../../../dropdown/dropDown.index";
import Button from "../../../../../button/button.index";
import Dialog from "../../../../../dialog/dialog.index";
import { syncFileManager } from "../../../../fileManager.function";
import { toast } from "mobin-toast";
import { toastMessages } from "../../../../../../../scripts/toastMessages";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

const publicLinkDropDownOptions = [
    { label: "خواندن", payload: 0 },
    { label: "نوشتن", payload: 1 }
];

const FolderPublicLinksModal = () => {
    const { selectedResources, publicLinkFolderModalStatus } = useAppSelector(
        ({ fileManager: { selectedResources, publicLinkFolderModalStatus } }) => ({ selectedResources, publicLinkFolderModalStatus }),
        shallowEqual
    );
    const [step, setStep] = useState<number>(1);
    const [selected, setSelected] = useState(publicLinkDropDownOptions[0]);
    const [publicLink, setPublicLink] = useState("");

    const handleCreateLink = () => {
        return new Promise((resolve) => {
            post(
                (data, status) => {
                    if (responseValidator(status)) {
                        setStep(2);
                        setPublicLink(`${window.location.origin}/public?path=${selectedResources[0].id}`);
                        syncFileManager();
                    }
                    resolve(true);
                },
                API.share.setPermission("v2", selectedResources[0].id),
                [
                    {
                        user: null,
                        access: selected.payload
                    }
                ]
            );
        });
    };

    const handleCopyPublicLink = (link: string, closeModal = true) => {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link);
            toast({ title: toastMessages(30), type: "success" });
        }

        if (closeModal) {
            handleSetPublicLinkFolder(false);
            setStep(1);
            setSelected(publicLinkDropDownOptions[0]);
            setPublicLink("");
        }
    };

    return (
        <>
            <Dialog status={publicLinkFolderModalStatus} onClose={() => handleSetPublicLinkFolder(false)} title="ایجاد لینک دسترسی">
                <div className="p-4">
                    {step === 1 ? (
                        <>
                            <Dropdown
                                options={publicLinkDropDownOptions}
                                value={selected}
                                onChange={setSelected}
                                title="نوع دسترسی"
                                classNames="mt-2 mb-2 py-3 pr-2"
                            />

                            <Button text="ایجاد لینک" className="w-full mt-7" onClick={handleCreateLink} autoFocus={true} />
                        </>
                    ) : (
                        <div>
                            <div className="flex justify-between bg-[#EFF0F6] rounded-[10px] p-4 mt-5">
                                <span
                                    className="border-l-2 border-secondary-300 pl-4 cursor-pointer"
                                    onClick={() => handleCopyPublicLink(publicLink, false)}
                                >
                                    <Copy />
                                </span>
                                <p className="text-secondary-400 w-full whitespace-nowrap overflow-hidden text-ellipsis" style={{ direction: "ltr" }}>
                                    {publicLink}
                                </p>
                            </div>

                            <Button text="کپی کردن لینک" className="w-full mt-6" onClick={() => handleCopyPublicLink(publicLink)} autoFocus={true} />
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default FolderPublicLinksModal;
